import { HistoryListBlock } from './HistoryListBlock'
import { PlanMenuCloseTagsBlock } from './PlanMenuCloseTagsBlock'
import { CommentBlock } from 'pages/PlanMenuControl/components/CommentBlock'
import { IPlanMenuCloseOrderDetailDto } from 'core/api/dto/PlanMenuCloseDto'
import React from 'react'
import { PlanMenuStatusType } from 'core/api/dto/PlanMenuControlDto'
import { AppInput, InputMaskType } from 'components/AppInput/AppInput'
import { ITag } from 'core/api/dto/TagsDto'

export interface IInfoBlockProps {
  width: number
  orderDetail?: IPlanMenuCloseOrderDetailDto | undefined
  orderId: string | null
  editMode: boolean
  numberOfPersonsFact: number
  setNumberOfPersonsFact: (value: string) => void
  numberOfSold: number
  setNumberOfSold: (value: string) => void
  comments: string
  setComments: React.Dispatch<React.SetStateAction<string>>
  tags: ITag[]
  setTags: React.Dispatch<React.SetStateAction<ITag[]>>
  setLocalComments: React.Dispatch<React.SetStateAction<string>>
  clientsInputRef?: React.RefObject<HTMLInputElement>
}

export const InfoBlock = ({
  width,
  orderId,
  orderDetail,
  editMode,
  numberOfPersonsFact,
  setNumberOfPersonsFact,
  numberOfSold,
  setNumberOfSold,
  comments,
  setComments,
  tags,
  setTags,
  setLocalComments,
  clientsInputRef,
}: IInfoBlockProps) => {
  return (
    <>
      <div className="row">
        <div
          className={`width-${width <= 1024 ? (width <= 768 ? 100 : 50) : 50}`}
        >
          {orderDetail && orderId && (
            <div className="dishes-list-wrap">
              <div className="user-block">
                {orderDetail && orderId && (
                  <React.Fragment>
                    <AppInput
                      value={`${numberOfPersonsFact}`}
                      onChange={setNumberOfPersonsFact}
                      label="Фактическое количество гостей"
                      inputMask={InputMaskType.integer}
                      placeholder="Введите количество гостей"
                      disabled={
                        orderDetail?.planMenuStatus ===
                          PlanMenuStatusType.Closed || !editMode
                      }
                      maxLength={6}
                      ref={clientsInputRef}
                    />
                    <AppInput
                      value={`${numberOfSold}`}
                      onChange={setNumberOfSold}
                      label="Количество проданных (дополнительные)"
                      placeholder="Введите количество проданных (дополнительные)"
                      inputMask={InputMaskType.integer}
                      disabled={
                        orderDetail?.planMenuStatus ===
                          PlanMenuStatusType.Closed || !editMode
                      }
                      maxLength={6}
                    />
                  </React.Fragment>
                )}
                <CommentBlock
                  editMode={editMode}
                  commentMain={comments}
                  updateComment={setComments}
                  disabled={
                    orderDetail?.planMenuStatus === PlanMenuStatusType.Closed ||
                    !editMode
                  }
                  icoNone
                  getComment={setLocalComments}
                />
              </div>
              <PlanMenuCloseTagsBlock
                tags={tags}
                setTags={setTags}
                editMode={editMode}
                disabled={
                  orderDetail?.planMenuStatus === PlanMenuStatusType.Closed ||
                  !editMode
                }
              />
            </div>
          )}
        </div>
        <div
          className={`width-${width <= 1024 ? (width <= 768 ? 100 : 50) : 50}`}
        >
          {orderDetail && orderId && (
            <>
              <HistoryListBlock historyItems={orderDetail.history} />
            </>
          )}
        </div>
      </div>
    </>
  )
}
